import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from './Common';

// handle the private routes
function PrivateRoute({ children }) {
  const location = useLocation();
  const token = getToken();
  
  return token ? children : <Navigate to="/login" state={{ from: location }} replace />;
}

export default PrivateRoute;